package api.traak.toFirestore

import kotlinx.serialization.Serializable

@Serializable
data class SynchronizeBexioData(
    val teamId: String,
)
